import { handleActions } from 'redux-actions'
import { takeLatest } from 'redux-saga/effects'
import { oc } from 'ts-optchain'

import { fetchProfile } from '@/api/ProfileApi'
import { AddressType, EmptyAddress, IAddress, IUserProfile } from '@/domains/ProfileDomain'
import { IRootState } from '@/modules'
import { createFetchAction, createSaga } from '@/utils/actionUtils'
import { apiFailureReducer, apiSuccessReducer } from '@/utils/reducerUtils'

export const PROFILE = 'Profile'

export interface ISimpleProfileAddress {
  key: AddressType
  value: IAddress
}

interface IProfileState extends IUserProfile {}

const initialState: IProfileState = {
  imgUrl: '',
  custNm: '',
  usrAlias: '',
  emailAdr: '',
  phoneNo: '',
  lineId: '',
  homeAddress: EmptyAddress,
  bizAddress: EmptyAddress,
}

export const profileActions = {}

export const profileAsync = createFetchAction(PROFILE)

export const reducer = {
  [profileAsync.SUCCESS]: apiSuccessReducer,
  [profileAsync.FAILURE]: apiFailureReducer,
}

export const profileSelector = {
  name: (state: IRootState): string => oc(state[PROFILE]).custNm(''),
  profileImage: (state: IRootState) => oc(state[PROFILE]).imgUrl('') || null,
  emailName: (state: IRootState) => oc(state[PROFILE]).emailAdr('')
}

export const profileReducer = handleActions(reducer, initialState)
export const profileSaga = [
  takeLatest(profileAsync.FETCH, createSaga<IUserProfile>(profileAsync, fetchProfile)),
]
